export enum UserRole {
    SuperAdmin = 'SUPER_ADMIN',
    Admin = 'ADMIN',
    User = 'USER',
}

export type Access = 'ADMIN' | 'USER' | 'SUPER_ADMIN';
export type IAccess = Access[];
